<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/RRN0by/tc-custom/9781614234111.jpg?1736599700201" alt="This image is the cover for the book Ghosts and Legends of Michigan's West Coast, Haunted America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ghosts and Legends of Michigan's West Coast, Haunted America
      </h1>
      <p class="bookDescription body article font2">
        <b>Stories and photos that bring the spooky history of Western Michigan to life . . . </b><br/>  <br/> Western Michigan is home to some of the state’s most picturesque places—and also some of its most chilling tales. Ghost story researcher Amberrose Hammond exposes the mysterious and spirit-ridden world of many beloved Michigan destinations as she skillfully weaves narratives of a world unseen by most. From the lingering spirit forever working in the Grand Theatre and the band of melon-headed children prowling the Saugatuck Dunes State Park to the lights of the Lake Forest Cemetery staircase waiting to reveal one’s place in the afterlife, these tales are sure to give pause to anyone daring enough to experience these hauntingly beautiful spots . . . after dark.<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Amberrose Hammond
      </h2>
      
      <p class="authorDescription body article">Amberrose Hammond earned a BA in English from Grand Valley State University in 2005. In 2006, her pursuits into strange history led her to design and develop Michigan's Otherside, a website on the unusual and mysterious worlds of Michigan, past and present. She published her first book with The History Press in 2009 titled, "Ghosts & Legends of Michigan's West Coast," and her second book, "Wicked Ottawa County, Michigan," in 2011.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Haunted America
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3eac06b4